"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm$data$punchIn, _vm$data$punchIn2, _vm$data$punchIn3, _vm$data$punchIn4, _vm$data$punchOut, _vm$data$punchOut2, _vm$data$punchOut3, _vm$data$punchOut4;
  var _vm = this,
    _c = _vm._self._c;
  return _c("b-modal", {
    attrs: {
      active: _vm.isModalActive,
      width: 640,
      scroll: "keep"
    },
    on: {
      close: function close($event) {
        return _vm.$emit("onClose");
      }
    }
  }, [_c("div", {
    staticClass: "modal-card"
  }, [_c("header", {
    staticClass: "modal-card-head"
  }, [_c("p", {
    staticClass: "modal-card-title"
  }, [_vm._v("\n        Detalhes da Marcação\n      ")]), _vm._v(" "), _c("button", {
    staticClass: "delete",
    attrs: {
      type: "button"
    },
    on: {
      click: function click($event) {
        return _vm.$emit("onClose");
      }
    }
  })]), _vm._v(" "), _c("section", {
    staticClass: "modal-card-body"
  }, [_c("b-field", {
    attrs: {
      label: "Funcionário"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.data.user.firstName) + " " + _vm._s(_vm.data.user.lastName) + " - " + _vm._s(_vm.data.user.email) + "\n      ")]), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "CPF"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.data.user.cpf) + "\n      ")]), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Data"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.formatDate(_vm.data.date)) + "\n      ")]), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Tempo Trabalhado"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.formatSeconds(_vm.data.workedSeconds)) + "\n      ")]), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Horário de entrada"
    }
  }, [_vm._v("\n        Submetido: " + _vm._s(_vm.formatTime((_vm$data$punchIn = _vm.data.punchIn) === null || _vm$data$punchIn === void 0 ? void 0 : _vm$data$punchIn.originalSubmittedTime)) + " "), _c("br"), _vm._v("\n        Editado: " + _vm._s(_vm.formatTime((_vm$data$punchIn2 = _vm.data.punchIn) === null || _vm$data$punchIn2 === void 0 ? void 0 : _vm$data$punchIn2.clockedAt)) + "\n      ")]), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Local de entrada"
    }
  }, [_vm._v("\n        Latitude: " + _vm._s(((_vm$data$punchIn3 = _vm.data.punchIn) === null || _vm$data$punchIn3 === void 0 ? void 0 : _vm$data$punchIn3.latitude) || "--") + " "), _c("br"), _vm._v("\n        Longitude: " + _vm._s(((_vm$data$punchIn4 = _vm.data.punchIn) === null || _vm$data$punchIn4 === void 0 ? void 0 : _vm$data$punchIn4.longitude) || "--") + "\n      ")]), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Horário de saída"
    }
  }, [_vm._v("\n        Submetido: " + _vm._s(_vm.formatTime((_vm$data$punchOut = _vm.data.punchOut) === null || _vm$data$punchOut === void 0 ? void 0 : _vm$data$punchOut.originalSubmittedTime)) + " "), _c("br"), _vm._v("\n        Editado: " + _vm._s(_vm.formatTime((_vm$data$punchOut2 = _vm.data.punchOut) === null || _vm$data$punchOut2 === void 0 ? void 0 : _vm$data$punchOut2.clockedAt)) + "\n      ")]), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Local de saída"
    }
  }, [_vm._v("\n        Latitude: " + _vm._s(((_vm$data$punchOut3 = _vm.data.punchOut) === null || _vm$data$punchOut3 === void 0 ? void 0 : _vm$data$punchOut3.latitude) || "--") + " "), _c("br"), _vm._v("\n        Longitude: " + _vm._s(((_vm$data$punchOut4 = _vm.data.punchOut) === null || _vm$data$punchOut4 === void 0 ? void 0 : _vm$data$punchOut4.longitude) || "--") + "\n      ")])], 1)])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;